<template>
  <v-autocomplete
    :clearable="canClear"
    :items="dispItems"
    :loading="loading"
    ref="ctrl"
    v-bind="$attrs"
    v-on="$listeners"
  ></v-autocomplete>
</template>
<script>
export default {
  props: ['url', 'filter', 'init', 'all'],
  data() {
    return {
      loading: false,
      clearable: true,
      items: []
    }
  },
  computed: {
    canClear() {
      if (this.$attrs.clearable === undefined) return true
      return this.$attrs.clearable
    },
    dispItems() {
      if (this.filter) {
        return this.items.filter(this.filter)
      } else {
        return this.items
      }
    }
  },
  mounted() {
    this.load()
  },

  methods: {
    load(term) {
      this.loading = true
      return this.$http
        .get(this.url, { params: { term: term }, quiet: true })
        .then(res => {
          this.items = res.data
          if (this.all) {
            this.items = [this.all, ...res.data]
          }
          if (this.init) {
            let result = this.dispItems.find(this.init)
            if (!result) return
            this.$emit(
              'input',
              this.$refs.ctrl.returnObject
                ? result
                : result[this.$refs.ctrl.itemValue]
            )
          }
          this.loading = false
          this.$emit('loadData', this.items)
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

